<template lang="pug">
    el-dialog(title="安排裁判" :fullscreen="false" :close-on-click-modal='false' :visible.sync="visible" width="80%" :modal-append-to-body='false' :append-to-body="true" @close="updateReferee_cancelClose")
        el-row
            el-col(:span="11")
                el-card(shadow="never")
                    div(slot="header" style="display: flex;")
                        el-input(v-model="orgName" clearable style="flex: 1;" placeholder="请输入姓名/手机号码/级别")
                        el-button(icon="el-icon-search" style="margin-left: 10px;" @click="sizeChangeHandle(pageSize)") 查询
                    div
                        el-table(:data="leftData" border v-loading='memberOrgListLoading' @selection-change="checkAll" max-height="300")
                            el-table-column(type="selection" align='center')
                            el-table-column(prop="name" label="姓名" align='center')
                            el-table-column(prop="gender" label="性别" align='center'  )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                            el-table-column(prop="level" label="级别" align='center'  )
                            el-table-column(prop="tel" label="手机号码" align='center' )
                        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
            el-col(:span="2")
                div.opSetting
                    div(@click="handelSelect")
                        el-button(style='padding:10px' icon="el-icon-d-arrow-right" :disabled="nowSelectData.length ? false:true" :size="buttonSize" type="primary") 选中
                    div.spacing(@click="handleRemoveSelect")
                        el-button(style='padding:10px' icon="el-icon-d-arrow-left" :disabled="nowSelectRightData.length ? false:true" :size="buttonSize" type="danger") 取消
            el-col(:span="11")
                el-card(shadow="never")
                    div(slot="header")
                        font.font_label 已选择的裁判
                    div
                        el-table(:data="rightData" border @selection-change="checkRightAll" max-height="300" )
                            el-table-column(type="selection" align='center')
                            el-table-column(prop="name" label="姓名" align='center' )
                            el-table-column(prop="gender" label="性别" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                            el-table-column(prop="level" label="级别" align='center' )
                            el-table-column(prop="tel" label="手机号码" align='center' )
        span.dialog-footer(slot="footer")
            el-button(@click="comfirmReferee" type="primary") 确 定
            el-button(@click="visible=false") 取 消
</template>
<script>
    export default{
        data(){
            return {
                visible:false,
                leftData:[],
                loading:null,
                buttonSize: 'large',
                rightData:[],  // 右边列表
                nowSelectData: [], // 左边选中列表数据
                nowSelectRightData: [], // 右边选中列表数据
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                memberOrgListLoading: false,
                orgIdList: [],
                ctId: '',
                orgName: '',
                ctRefereeSetList: []
            }
        },
        methods: {
            init(row){
                console.log(row)
                this.orgName = null
                this.ctId = row.id
                this.leftData = []
                this.rightData = []
                this.orgIdList = []
                this.nowSelectData = []
                this.nowSelectRightData = []

                this.visible = true
                this.$http({
                    url:this.$http.adornUrl(`/ctReferee/getRefListByCtId`),
                    method:'post',
                    params:this.$http.adornParams({
                        'ids':row.id || null
                    })
                }).then((data)=>{
                    // if(data && data.code === 0){
                    //     for(let i of data.list){
                    //         i.ctId = row.id
                    //         i.refereeId = i.id
                    //     }
                    //     this.leftData = data.list
                    // }
                    if (data && data.code === 0) {
                        this.leftData = data.page.records;
                        this.rightData = data.list;
                        this.totalPage = data.page.total;
                    } else {
                        this.leftData = [];
                        this.totalPage = 0;
                    }
                })
            },
            getDataList() {
                this.memberOrgListLoading = true;
                this.rightData.forEach(data => {
                    this.orgIdList.push(data.id);
                });
                this.$http({
                    url: this.$http.adornUrl("/ctReferee/ctRefereeList"),
                    method: "get",
                    params: this.$http.adornParams({
                        page: this.pageIndex,
                        limit: this.pageSize,
                        name: this.orgName,
                        orgIdList: JSON.stringify(this.orgIdList)
                    })
                }).then(data => {
                    if (data && data.code === 0) {
                        this.leftData = []
                        if(data.page.records.length>0) {
                            data.page.records.forEach(e=>{
                                let x = true
                                for (let i = 0; i < this.rightData.length; i++) {
                                    if (this.rightData[i].id == e.id) {
                                        x = false
                                    }
                                }
                                if(x) {
                                    this.leftData.push(e)
                                }
                            })
                        }
                        // this.leftData = data.page.records;
                        this.totalPage = data.page.total;
                    } else {
                        this.leftData = [];
                        this.totalPage = 0;
                    }
                    this.memberOrgListLoading = false;
                });
            },
            openFullScreen() {
                this.loading  = this.$loading({
                    lock: true,
                    text: '加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },
            comfirmReferee(){
                if(this.rightData.length === 0){
                    // this.$message.error("请勾选要安排的裁判！")
                    // return
                    this.ctRefereeSetList = []
                    // this.rightData.forEach(data => {
                    //     this.ctRefereeSetList.push({
                    //         'ctId': this.ctId,
                    //         'refereeId': data.id
                    //     });
                    // });
                    let parmas = [{
                            'ctId': this.ctId,
                            'refereeId': null
                        }]
                    this.openFullScreen()
                    this.$http({
                        url:this.$http.adornUrl(`/crefereeSetting/addList`),
                        method:'post',
                        data: parmas
                    }).then((data) =>{
                        if(data && data.code ===0){
                            this.visible = false
                            this.$message.success("操作成功!")
                            this.$emit('refreshDataList')
                        }else{
                            this.$message.success("操作失败!")
                        }
                        this.loading.close()
                    }).catch(() =>{
                        this.loading.close()
                    })
                } else {
                    this.ctRefereeSetList = []
                    this.rightData.forEach(data => {
                        this.ctRefereeSetList.push({
                            'ctId': this.ctId,
                            'refereeId': data.id
                        });
                    });
                    this.openFullScreen()
                    this.$http({
                        url:this.$http.adornUrl(`/crefereeSetting/addList`),
                        method:'post',
                        data:this.ctRefereeSetList
                    }).then((data) =>{
                        if(data && data.code ===0){
                            this.visible = false
                            this.$message.success("操作成功!")
                            this.$emit('refreshDataList')
                        }else{
                            this.$message.success("操作失败!")
                        }
                        this.loading.close()
                    }).catch(() =>{
                        this.loading.close()
                    })
                }
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            checkAll(val){
                this.nowSelectData = val;
            },
            checkRightAll(val) {
                this.nowSelectRightData = val;
            },
            // 选中
            handelSelect(){
                this.rightData = this.handleConcatArr(this.rightData, this.nowSelectData)
                this.handleRemoveTabList(this.nowSelectData,  this.leftData);
                this.nowSelectData = [];
            },
            // 取消
            handleRemoveSelect() {
                this.leftData = this.handleConcatArr(this.leftData, this.nowSelectRightData)
                this.handleRemoveTabList(this.nowSelectRightData,  this.rightData);
                this.nowSelectRightData = [];
            },
            handleConcatArr(rightData, nowSelectData) {
                let arr = [];
                arr = arr.concat(rightData, nowSelectData);
                return arr;
            },
            handleRemoveTabList(isNeedArr,  originalArr) {
                if(isNeedArr.length && originalArr.length) {
                    for(let i=0; i<isNeedArr.length; i++) {
                        for(let k=0; k<originalArr.length; k++) {
                            if(isNeedArr[i]["name"] === originalArr[k]["name"]) {
                                originalArr.splice(k, 1);
                            }
                        }
                    }
                }
            },
            updateReferee_cancelClose () {
                this.orgName = ''
                this.pageIndex = 1
                this.pageSize = 10
            }
        }
    }
</script>